import src from "IMAGE";
export default { src, width: 263, height: 88, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAAAAACLoxGUAAAAJklEQVR42mP49OnT5+/fPn1gOHHq5OU7t249Zvj48eOnL5+fPwIAJbYVr1b5O+QAAAAASUVORK5CYII="};
